import React from 'react';
import { styled } from '@miro-site/ui-styled-engine';
import { Section, Grid, GridItem } from '@miro-site/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
var HelpfulLink = styled('a', {
  border: '1px solid',
  borderColor: '$gray-30',
  borderRadius: '$100',
  boxShadow: '$100',
  backgroundColor: '$blue-10',
  padding: '$100 $150',
  display: 'inline-block',
  margin: '$50',
  '&:hover': {
    cursor: 'pointer',
    boxShadow: '$50'
  }
});

var HelpfulLinksSection = function HelpfulLinksSection(props) {
  var _props$links;

  return /*#__PURE__*/_jsx(Section, {
    pageTopInset: "1200",
    children: /*#__PURE__*/_jsx(Grid, {
      children: /*#__PURE__*/_jsx(GridItem, {
        xs: 12,
        children: props === null || props === void 0 ? void 0 : (_props$links = props.links) === null || _props$links === void 0 ? void 0 : _props$links.map(function (link, index) {
          return /*#__PURE__*/_jsx(HelpfulLink, {
            href: link === null || link === void 0 ? void 0 : link.link,
            children: link.title
          }, 'help-link-' + index);
        })
      })
    })
  });
};

export default HelpfulLinksSection;